export const API_SERVER_ADMIN = "https://rolas.site/admin/";
export const API_SERVER = "https://admin.rolas.in/";
export const LOCAL_SERVER = "http://127.0.0.1:6001/admin/";
 